import type { Card } from "@/components/server/EditSuscription/DeleteAccount/types";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { MarkdownCustom } from "./MarkdownCustom";

export type AdviceProps = {
    card: Card;
    onPausar: () => void;
    onChange: () => void;
};
export const Advice = ({ card, onPausar, onChange }: AdviceProps) => {
    return (
        <Alert variant="default" className="bg-primary/10 border-primary">
            <AlertDescription>
                {/* Use the new component to process the text with links */}
                <MarkdownCustom
                    onHashAction={(action) => {
                        switch (action) {
                            case "cambiar":
                                onChange();
                                break;
                            case "pausar":
                                onPausar();
                                break;
                        }
                    }}
                >
                    {card.body}
                </MarkdownCustom>
            </AlertDescription>
        </Alert>
    );
};
